import '.c6{position:relative;}.ssr-plugin'
import '.it{width:64px;}.ssr-plugin'
import '.iu{height:64px;}.ssr-plugin'
import '.aw{flex-shrink:0;}.ssr-plugin'
import '.d{position:absolute;}.ssr-plugin'
import '.iv{bottom:-4px;}.ssr-plugin'
import '.de{right:-4px;}.ssr-plugin'
import '.f1{border-radius:50%;}.ssr-plugin'
import '.iw{border:2px solid var(--shades-white);}.ssr-plugin'
import '.h{overflow:hidden;}.ssr-plugin'
import '.ix{width:32px;}.ssr-plugin'
import '.iy{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'
import { resizeImage } from '@app/util/helpers'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="c6 it iu aw"
    >
      {initiativeImage ? (
        <Image
          src={resizeImage(initiativeImage, 128)}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="d iv de f1 iw h ix iy"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
